// Web replacement for react-native-image-picker on top of <input type="file">.
import { registerFile } from '../fileRegistry';

export type Asset = {
  uri?: string;
  fileName?: string;
  fileSize?: number;
  type?: string;
  width?: number;
  height?: number;
};

export type ImagePickerResponse = {
  didCancel?: boolean;
  errorCode?: string;
  errorMessage?: string;
  assets?: Asset[];
};

type Options = { mediaType?: 'photo' | 'video' | 'mixed'; selectionLimit?: number; [key: string]: unknown };

const ACCEPT = { photo: 'image/*', video: 'video/*', mixed: 'image/*,video/*' } as const;

function pick(options: Options | undefined, capture: boolean): Promise<ImagePickerResponse> {
  return new Promise(resolve => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = ACCEPT[options?.mediaType ?? 'photo'];
    input.multiple = (options?.selectionLimit ?? 1) !== 1;
    if (capture) input.setAttribute('capture', 'environment');
    input.style.display = 'none';

    let settled = false;
    const finish = (result: ImagePickerResponse) => {
      if (settled) return;
      settled = true;
      input.remove();
      resolve(result);
    };

    input.addEventListener('change', () => {
      const list = Array.from(input.files ?? []);
      if (list.length === 0) return finish({ didCancel: true });
      finish({
        assets: list.map(file => ({
          uri: registerFile(file),
          fileName: file.name,
          fileSize: file.size,
          type: file.type,
        })),
      });
    });
    input.addEventListener('cancel', () => finish({ didCancel: true }));

    document.body.appendChild(input);
    input.click();
  });
}

export const launchImageLibrary = (options?: Options) => pick(options, false);
export const launchCamera = (options?: Options) => pick(options, true);
